export default __webpack_public_path__ + "static/media/features-home.be95fc4b.svg";